import React, { useCallback } from "react";
import { UpdateProfileBody } from "@common/schemas/user.schema";
import { useScope } from "@state/scopeContext.lib";
import { useUpdateUser } from "@hooks/useUpdateUser";
import { updateProfile } from "@lib/user";

import { PlainModal } from "@design-system/Modal/Modal";
import { useToaster } from "@design-system/ToastMessages/useToaster";
import { UpdateProfileFlow } from "./UpdateProfileFlow";
import { EditableProfileFields } from "./types";

interface Props {
    update: EditableProfileFields | null;
    onClose(): void;
}

export const UpdateProfileModal: React.FC<Props> = ({ update, onClose }) => {
    const updateUser = useUpdateUser();
    const { workspaceId } = useScope();
    const { toast, error } = useToaster();

    const handleSuccess = useCallback(
        async (payload: UpdateProfileBody) => {
            try {
                updateUser(
                    await updateProfile({
                        ...payload,
                        workspaceId: workspaceId ?? undefined,
                    }),
                );

                toast("Profile updated");

                onClose();
            } catch {
                error(`Error when updating profile`);
            }
        },
        [toast, error, onClose, updateUser, workspaceId],
    );

    if (!update) {
        return null;
    }

    return (
        <PlainModal show onHide={onClose}>
            <UpdateProfileFlow
                update={update}
                onSuccess={handleSuccess}
                onCancel={onClose}
            />
        </PlainModal>
    );
};
